type CalendarIconProps = React.SVGProps<SVGSVGElement>;

export const CalendarIcon = (props: CalendarIconProps) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M10.5 1H9V0H8V1H4V0H3V1H1.5C1.10218 1 0.720644 1.15804 0.43934 1.43934C0.158035 1.72064 0 2.10218 0 2.5L0 12H12V2.5C12 2.10218 11.842 1.72064 11.5607 1.43934C11.2794 1.15804 10.8978 1 10.5 1ZM1 2.5C1 2.36739 1.05268 2.24021 1.14645 2.14645C1.24021 2.05268 1.36739 2 1.5 2H10.5C10.6326 2 10.7598 2.05268 10.8536 2.14645C10.9473 2.24021 11 2.36739 11 2.5V4H1V2.5ZM1 11V5H11V11H1Z"
        fill="currentColor"
      />
      <path
        d="M8.50001 6.50005H7.5V7.50005H8.50001V6.50005Z"
        fill="currentColor"
      />
      <path
        d="M6.50001 6.50005H5.5V7.50005H6.50001V6.50005Z"
        fill="currentColor"
      />
      <path d="M4.5 6.50005H3.5V7.50005H4.5V6.50005Z" fill="currentColor" />
      <path
        d="M8.50001 8.50008H7.5V9.50008H8.50001V8.50008Z"
        fill="currentColor"
      />
      <path
        d="M6.50001 8.50008H5.5V9.50008H6.50001V8.50008Z"
        fill="currentColor"
      />
      <path d="M4.5 8.50008H3.5V9.50008H4.5V8.50008Z" fill="currentColor" />
    </svg>
  );
};
